import { GButton } from "../../../components/GButton";
import styles from "./css/DontHaveGarudaAccountButton.module.css";
import { KeycloakClientFactory } from "../../../helper/keycloak/factory";
import { Typography } from "@mui/material";

export const DontHaveGarudaAccountButton = () => {
  const keycloak = KeycloakClientFactory.getInstance();
  const handleClick = () => keycloak.register();

  return (
    <GButton
      data-testid="sign-up-btn"
      variant="contained"
      size="large"
      className={styles.button}
      onClick={handleClick}
    >
      <Typography variant="body2" className={styles.buttonText}>Don't have Garuda Account ? Sign up now</Typography>
    </GButton>
  );
};
